import { useCallback } from "react";
import { deleteFillableForm } from "../../../../acions/administration/fillableForms";
import { useDefaultDeleteModal } from "../../../../lib/hooks/defaultDeleteModal";

export const useDelete = (reloadData: () => void, close: () => void) => {
  const { openDeleteModal } = useDefaultDeleteModal(
    deleteFillableForm,
    reloadData,
    close,
  );

  const onDelete = useCallback(
    (id: string): void => {
      openDeleteModal(id, "Delete Fillable Form");
    },
    [openDeleteModal],
  );

  return { onDelete };
};
